import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extract a human-readable message from an unknown error value.
 * Handles native Errors, the ApiError thrown by the Orval mutator, and the
 * OpenAPI `Error` body shape ({ error, code? }).
 */
export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'object' && err !== null && 'error' in err) {
    const message = (err as { error: unknown }).error;
    if (typeof message === 'string') return message;
  }
  return 'Something went wrong';
}
